import React, { useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Navigate, useLocation } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import Loader from "../common/Loader/Loader";

const RequireAuth = ({ children }) => {
  const { authState } = useOktaAuth();
  const msalIsAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const { instance, inProgress } = useMsal();
  const isOktaReady = authState && !authState.isPending;
  const isOktaAuthenticated = authState?.isAuthenticated;

  if (!isOktaReady || inProgress !== InteractionStatus.None) {
    return <Loader />;
  }

  if (isOktaAuthenticated || msalIsAuthenticated) {
    return children;
  }
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default RequireAuth;
